import React from "react";
import { LHSDiv, ImageBox, BrandLogo, Heading } from "./styles";

function LHSSection({
  isDark = false,
  title = "",
  icon = "icon-brand-logo-light",
}) {
  return (
    <LHSDiv isDark={isDark}>
      <ImageBox>
        <BrandLogo icon={icon} height="12px" width="29px" />
      </ImageBox>
      {title && <Heading variant="label1">{title}</Heading>}
    </LHSDiv>
  );
}

export default LHSSection;
